"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const IContainerInjection_1 = require("auto-widget-framework/src//Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const FormValidatorTypes_1 = require("../Enum/FormValidatorTypes");
const FormValidationRendererTypes_1 = require("../Enum/FormValidationRendererTypes");
class MixedFormValidatorRenderer {
    constructor(formElement, questionnaire, validationConfig, factory) {
        this.baseRenderer = factory
            .create(FormValidatorTypes_1.FormValidatorTypes.BASE, {
            form: formElement,
            config: validationConfig
        });
        this.questionnaireRender = factory.create(FormValidationRendererTypes_1.FormValidationRendererTypes.QUESTIONNAIRE, {
            form: formElement,
            questionnaire: questionnaire
        });
    }
    static create(formElement, questionnaire, validationConfig, container) {
        return new this(formElement, questionnaire, validationConfig, container.get('factory.form_validation_renderer'));
    }
    display(errors) {
        let promises = [];
        promises.push(this.baseRenderer.display(errors));
        promises.push(this.questionnaireRender.display(errors));
        return Promise.all(promises);
    }
    displayForField(inputName, error) {
        let promises = [];
        promises.push(this.baseRenderer.displayForField(inputName, error));
        promises.push(this.questionnaireRender.displayForField(inputName, error));
        return Promise.all(promises);
    }
    removeForAll() {
        let promises = [];
        promises.push(this.baseRenderer.removeForAll());
        promises.push(this.questionnaireRender.removeForAll());
        return Promise.all(promises);
    }
    removeForField(inputName) {
        let promises = [];
        promises.push(this.baseRenderer.removeForField(inputName));
        promises.push(this.questionnaireRender.removeForField(inputName));
        return Promise.all(promises);
    }
}
exports.default = MixedFormValidatorRenderer;
Mixin_1.default(MixedFormValidatorRenderer, IContainerInjection_1.default);
